import mailVistaLogo from "@/assets/icons/mailvista-logo.svg";
import Ellipse from "@/assets/style/Ellipse.svg";
import SafeImage from "@/components/SafeImage";
import { cn } from "@/lib/utils";

type EscapeScreenLayoutProps = {
    children: React.ReactNode;
    className?: string;
};

const EscapeScreenLayout = ({
    children,
    className,
}: EscapeScreenLayoutProps) => (
    <div className="relative flex min-h-screen w-full flex-col overflow-hidden bg-surface-background">
        <SafeImage
            alt=""
            aria-hidden
            className="pointer-events-none absolute top-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
            src={Ellipse}
        />
        <SafeImage
            alt=""
            aria-hidden
            className="pointer-events-none absolute -right-32 bottom-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
            src={Ellipse}
        />

        <div
            className={cn(
                "relative flex flex-1 flex-col items-center justify-center px-6 py-12",
                className,
            )}
        >
            <SafeImage
                alt="Mailvista"
                className="mb-10 h-9 w-auto"
                src={mailVistaLogo}
            />
            {children}
        </div>
    </div>
);

export default EscapeScreenLayout;
